export default "__VITE_ASSET__CJW1iU79__"